<template>
  <q-banner
    v-if="!online"
    class="bg-warning text-white text-center q-py-xs"
    dense
  >
    <q-icon name="wifi_off" size="sm" class="q-mr-sm" />
    Keine Internetverbindung – Änderungen werden möglicherweise nicht gespeichert
  </q-banner>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'

export default {
  name: 'OfflineIndicator',
  setup() {
    const online = ref(navigator.onLine)

    function setOnline() { online.value = true }
    function setOffline() { online.value = false }

    onMounted(() => {
      window.addEventListener('online', setOnline)
      window.addEventListener('offline', setOffline)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('online', setOnline)
      window.removeEventListener('offline', setOffline)
    })

    return { online }
  }
}
</script>
